/**
 * 스위치 (DESIGN_SPEC 6장). 트랙 44×26 + 손잡이 20, 터치 영역 48×44, role="switch".
 * 켜짐 --color-brand, 꺼짐 --color-switch-off.
 */
export function Switch({ checked, onChange, label, disabled = false }) {
    return (
        <button
            type="button"
            role="switch"
            aria-checked={checked}
            aria-label={label}
            disabled={disabled}
            onClick={() => {
                onChange(!checked);
            }}
            className="flex h-11 w-12 shrink-0 items-center justify-center disabled:opacity-40"
        >
            <span
                className={`relative block h-[26px] w-11 rounded-full transition-colors ${
                    checked ? 'bg-brand' : 'bg-switch-off'
                }`}
            >
                <span
                    className={`absolute top-[3px] block size-5 rounded-full bg-surface transition-[left] ${
                        checked ? 'left-[21px]' : 'left-[3px]'
                    }`}
                />
            </span>
        </button>
    );
}
